import { getTheme } from "@fluentui/react";

import { BaseDomain } from "@/interfaces/shared/base-domain.types";

const theme = getTheme();

export enum ContractShipmentType {
  POST_OFFICE = "POST_OFFICE",
  POUCH = "POUCH"
}

export const contractShipmentTypeLabels: Record<ContractShipmentType, string> =
  {
    [ContractShipmentType.POST_OFFICE]: "Correios",
    [ContractShipmentType.POUCH]: "Malote"
  };

export enum ContractShipmentStatus {
  IN_TRANSIT = "IN_TRANSIT",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED"
}

export type ContractShipmentAction =
  "CREATE" | "EDIT" | "CONFIRM_DELIVERY" | "CANCEL";

export const contractShipmentStatusLabels: Record<
  ContractShipmentStatus,
  string
> = {
  [ContractShipmentStatus.IN_TRANSIT]: "A caminho",
  [ContractShipmentStatus.COMPLETED]: "Concluído",
  [ContractShipmentStatus.CANCELED]: "Cancelado"
};

export const contractShipmentStatusColors: Record<
  ContractShipmentStatus,
  string
> = {
  [ContractShipmentStatus.IN_TRANSIT]: theme.palette.blueDark,
  [ContractShipmentStatus.COMPLETED]: theme.palette.greenDark,
  [ContractShipmentStatus.CANCELED]: theme.semanticColors.severeWarningIcon
};

export interface ContractShipment extends BaseDomain {
  contractId: number;
  type: ContractShipmentType;
  status: ContractShipmentStatus;
  code: string;
  cost: number;
  notes?: string;
  receivedAt?: string;
}
